export enum DecisionUpdateReasons {
  INCORRECT_AMENDMENT_LANGUAGE = 'Incorrect amendment language',
  NEW_INFORMATION_ABOUT_APPLICANT = 'Learned new information about applicant',
  UW_ERROR = 'Underwriter error',
  INCORRECT_MAX_COVERAGE = 'Incorrect max coverage',
  OTHER = 'Other',
}
